/** @file Client-side check of a command input with the command's own zod schema (the server's first step). */
import { lookupCommand } from '@pose2d/commands/lookupCommand';
import { parseOrThrow } from '@pose2d/format/parseOrThrow';
import { throwError } from '@pose2d/format/throwError';
import { toPose2DError } from '@pose2d/format/toPose2DError';
import type { Pose2DError } from '@pose2d/format/types';

/** The error applyCommand would raise before applying (VALIDATION with the dotted issue path), or null. */
export function validateInput(command: string, input: unknown): Pose2DError | null {
  try {
    const def = lookupCommand(command) ?? throwError('NOT_FOUND', { kind: 'command', ref: command });
    parseOrThrow(def.input, input);
    return null;
  } catch (thrown) {
    const error = toPose2DError(thrown);
    if (error === null) throw thrown;
    return error;
  }
}
